import { useLayoutEffect, useState } from "react";

/**
 * Helper  Frontend + Backend
 *
 * @param {number} headerHeight
 * @param {number} scrollPos
 * @returns {object}
 */
export function getSericeHeaderBackgroundScrollProps(headerHeight, scrollPos) {
  const factory = {
    opacity: 0.8,
    scale: 0.15,
    y: 0.75,
  };
  const maxWay = headerHeight * 0.5;
  const opacity = Math.max(0, 1 - (scrollPos / maxWay) * factory.opacity);
  const scale = Math.min(1, 1 - (scrollPos / maxWay) * factory.scale);
  const rotateX = 1 - scale * scale;
  const translateY = scrollPos * factory.y;

  return {
    opacity,
    scale,
    rotateX,
    translateY,
  };
}

/**
 * Use Hook for Backend
 *
 * @param {Ref} wrapperRef
 * @returns {object}
 */
export function useSerivceHeaderBackgroundScrollProps(wrapperRef) {
  const [imageOffset, setImageOffset] = useState(0);
  const [imageOpacity, setImageOpacity] = useState(1);
  const [imageScale, setImageScale] = useState(1);
  const [imageRotateX, setImageRotateX] = useState(0);

  useLayoutEffect(() => {
    window.addEventListener("scroll", onScroll, true);

    function onScroll(scrollEvent) {
      const headerHeight = wrapperRef?.current?.offsetHeight || 0;
      const scrollPos = scrollEvent.target.scrollTop;

      if (scrollPos > headerHeight) return;

      const { opacity, scale, rotateX, translateY } =
        getSericeHeaderBackgroundScrollProps(headerHeight, scrollPos);

      setImageOffset(translateY);
      setImageOpacity(opacity);
      setImageScale(scale);
      setImageRotateX(rotateX);
    }

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return { imageOffset, imageOpacity, imageScale, imageRotateX };
}
